import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Request } from '../_service/request';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver/dist/FileSaver';

@Component({
  selector: 'app-prop-desc-page',
  templateUrl: './prop-desc-page.component.html',
  styleUrls: ['./prop-desc-page.component.scss']
})
export class PropDescPageComponent implements OnInit {

  constructor(
    private activeRoute: ActivatedRoute,
    private request: Request,
    private modalService: NgbModal,
    private http: HttpClient
  ) { }
  actionName8 = 'welcome8'
  actionName9: any;
  actionName10: any;
  isEnabled = false
  pid: any;
  propData: any;
  propGalary: any;
  server_url = this.request.server_url;
  isDownloadClicked = false;
  ngOnInit(): void {

    this.activeRoute.queryParams.subscribe(params => {
      this.pid = params['pid'] ? params['pid'] : '0';
    });
    // console.log(this.pid)
    this.getPropDescDetails()
  }


  async getPropDescDetails() {
    let temp = this.request.get_structure('prop_desc', 'format');
    temp.property_id = Number(this.pid)
    console.log(temp);
    temp = await this.request.post(0, 'prop_desc', temp);
    console.log(temp,'ttttttttttttttttttttttttttttttt');
    if (temp[0] == 200) {
      this.isEnabled = true
      this.propData = temp[1]['response']['data']['property_details'][0]
      this.propGalary = temp[1]['response']['data']['property_gallery']
      // this.actionName8 = temp[1]['response']['data']['property_details'][0]['location']
      this.actionName9 = temp[1]['response']['data']['property_details'][0]
      // this.actionName9 = temp[1]['response']['data']['property_details'][5]['location']
console.log(this.actionName9,'wwwwwwwwwwwwwwww');


      let myArray1 = this.actionName9.location.split(",");
      if (this.actionName9.city == '') {
        this.actionName8 = this.actionName9.location
      } else if (this.actionName9.city != "") {
        this.actionName8 = this.actionName9.city + myArray1[1];
      }
console.log(myArray1,'rrrrrrrrrrrrrrrrrrrrr');
console.log(this.actionName8,'pppppppppp')


    } else if (temp[0] == 400) {
      this.isEnabled = false
    }
  }


  viewImage(imageModal) {
    this.modalService.open(imageModal, { keyboard: false, backdrop: 'static', size: 'xl' })
  }

  download(data) {
    this.isDownloadClicked = true
    this.http.get<any>(this.server_url + data.brochure_url, { responseType: 'blob' as 'json' }).subscribe(pdf => {
      const blob = new Blob([pdf], { type: 'application/pdf' });
      const fileName = data.property_title + '.pdf';
      // window.open(this.server_url + data.brochure_url, '_blank')
      this.isDownloadClicked = false
      console.log('brochure')
      saveAs(blob, fileName);
    }, err => {
      console.log(err);
    });
  }

}
